/*!
    * @product/scmp-sdk 1.1.39
    * built by undefined
  */
import{i as t}from"./chunk-XHSWPLIC.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-3WNVP356.js.map
